module.exports = __webpack_public_path__ + "img/20190821145414QQ截图20190821130847.017e92e4.png";